import { use } from 'react';
import { DeviceHeaderContext } from './DeviceHeaderContext';

/**
 * This hook retrieves the provided headers promise from the root layout and resolves it to get the device type
 * @returns
 */
export const useDeviceHeader = () => {
  const headersPromise = use(DeviceHeaderContext);

  if (!headersPromise) {
    throw new Error('useDeviceHeader must be used within a DeviceHeaderProvider');
  }

  return use(headersPromise);
};
